import { useQuery, UseQueryOptions } from 'react-query';
import { searchAuditEvents } from './api';
import { SearchAuditEventsRequest, SearchAuditEventsResponse } from './types';

export const phoneAuditsQueryKeys = {
  searchAuditEvents: (req: SearchAuditEventsRequest) => ['phone', 'audits', 'searchAuditEvents', req],
};

export const useSearchAuditEvents = (
  req: SearchAuditEventsRequest,
  options?: Omit<UseQueryOptions<SearchAuditEventsResponse, unknown, SearchAuditEventsResponse>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<SearchAuditEventsResponse, unknown>({
    queryKey: phoneAuditsQueryKeys.searchAuditEvents(req),
    queryFn: () => searchAuditEvents(req),
    enabled: !!req.tenantId,
    ...options,
  });
};
